import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Loader from "../../common/Loader";
import Bread from "../../common/Bread";
import { LangContext } from "../../context/LangContext";
// import "./companyProfile.scss"; // Uncomment if needed for styles

const BankingHours = () => {
  const { state } = useContext(LangContext);
  const nep = state.np;

  const {
    isLoading,
    error,
    data: detail,
    isFetching,
  } = useQuery({
    queryKey: ["BankingHoursData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/page/detail/banking-hours`)
        .then((res) => res.data.detail),
  });

  // Show loader while loading
  if (isLoading) return <Loader />;

  // Show error message
  if (error) {
    return (
      <div className="error-message">
        <p>Sorry, something went wrong while loading the banking hours.</p>
        <p>{error.message}</p>
      </div>
    );
  }

  // Select the correct description based on language
  const description = nep ? detail?.np?.Description : detail?.en?.Description;

  const breadcrumList = {
    image: "",
    title: nep ? "बैंकिङ समय" : "Banking Hours",
    l1: nep ? "गृहपृष्ठ" : "Home",
    l2: nep ? "बैंकिङ समय" : "Banking Hours",
    l3: "",
  };

  return (
    <Bread data={breadcrumList}>
      {isFetching && <div className="fetching-indicator">Updating...</div>}

      <div
        style={{ textAlign: "justify", hyphens: "auto" }}
        className="companyProfileCKContainer"
        dangerouslySetInnerHTML={{
          __html: description || "No data available.",
        }}
      ></div>
    </Bread>
  );
};

export default BankingHours;
